import React from 'react';
import PropTypes from 'prop-types';

import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { uniqueId } from 'lodash';
import { STATE_LIST } from './stateOptions';

const LABEL_TOGGLE_WIDTH = 150;

export const StateSelect = ({
  required,
  id,
  model,
  label,
  inputClass,
  errorClass,
  baseStyles,
  parentBounds,
  ...props
}) => {
  const parentWidth = Math.floor(parentBounds.width) || LABEL_TOGGLE_WIDTH;
  const labelKey = parentWidth < LABEL_TOGGLE_WIDTH ? 'value' : 'label';
  return (
    <React.Fragment>
      <SelectInput
        model={model}
        label={label}
        placeholder="Select One"
        data-testid={id}
        className={inputClass}
        isSearchable
        isClearable
        options={STATE_LIST}
        labelKey={labelKey}
        name={`${model}-select-input-${uniqueId()}`}
        autoComplete="none"
        validators={{ required: true }}
      />
    </React.Fragment>
  );
};

StateSelect.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  errorClass: PropTypes.string,
  inputClass: PropTypes.string,
  baseStyles: PropTypes.shape({}),
  parentBounds: PropTypes.shape({ width: PropTypes.number }),
};

StateSelect.defaultProps = {
  required: false,
  id: 'state-select-list-input',
  label: 'State',
  errorClass: '',
  inputClass: '',
  baseStyles: {},
  parentBounds: {},
};
